import { render, staticRenderFns } from "./AllRestaurantsInvoices.vue?vue&type=template&id=54baeb10&"
import script from "./AllRestaurantsInvoices.vue?vue&type=script&lang=js&"
export * from "./AllRestaurantsInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports